import { API_URL } from "env";
import { uploadMediaImage } from "./Media";

async function getUserInfo(): Promise<any> {
    try {
        const response = await fetch(API_URL + '/api/v1/fe/customer/profile', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
        });

        if (!response.ok) {
            if (response.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                console.warn('Unauthorized access - perhaps the user is not logged in.');
                return null;
            }
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data.data || null;
    } catch (error) {
        console.error('Failed to fetch user info:', error);
        return null;
    }
}
interface UpdateInterface {
    fullname?: string,
    phone?: string,
    dob?: string,
    avatar?: File,
    // Business info
    business_name?: string,
    business_type?: string,
    business_province?: string,
    business_image?: File,
    business_district?: string,
    business_ward?: string,
    business_address?: string,
    // Bank info
    bank_name?: string,
    bank_number?: string,
    bank_account?: string,
}

async function updateUserInfo(updateData: UpdateInterface): Promise<void> {
    try {
        let avatarPath = "";
        if (updateData.avatar && updateData.avatar instanceof File) {
            const uploadRes = await uploadMediaImage(updateData.avatar);
            if (uploadRes && uploadRes.status) {
                avatarPath = uploadRes.data.image;
            }
        }
        let businessImagePath = "";
        if (updateData.business_image && updateData.business_image instanceof File) {
            const uploadRes = await uploadMediaImage(updateData.business_image);
            if (uploadRes && uploadRes.status) {
                businessImagePath = uploadRes.data.image;
            }
        }

        const body = new URLSearchParams();
        if (updateData.fullname) body.append('fullname', updateData.fullname);
        if (updateData.phone) body.append('phone', updateData.phone);
        if (updateData.dob) body.append('birthday', updateData.dob);
        if (avatarPath) body.append('avatar', avatarPath);
        
        if (updateData.business_name) body.append('business_name', updateData.business_name);
        if (updateData.business_type) body.append('business_type', updateData.business_type);
        if (businessImagePath) body.append('business_image', businessImagePath);
        if (updateData.business_province) body.append('business_province', updateData.business_province);
        if (updateData.business_district) body.append('business_district', updateData.business_district);
        if (updateData.business_ward) body.append('business_ward', updateData.business_ward);
        if (updateData.business_address) body.append('business_address', updateData.business_address);
        if (updateData.bank_name) body.append('bank_name', updateData.bank_name);
        if (updateData.bank_number) body.append('bank_number', updateData.bank_number);
        if (updateData.bank_account) body.append('bank_account', updateData.bank_account);

        const response = await fetch(API_URL + '/api/v1/fe/customer/update', {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: body.toString(),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    } catch (error) {
        console.error('Failed to update user info:', error);
    }
}

async function changePassword(currentPassword: string, newPassword: string, confirm_password: string): Promise<void> {
    try {
        const data = new FormData();
        data.append('old_password', currentPassword);
        data.append('new_password', newPassword);
        data.append('confirm_password', confirm_password);
        const response = await fetch(API_URL + '/api/v1/fe/customer/update_password', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
            body: data,
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        console.log('Password changed successfully');
    } catch (error) {
        console.error('Failed to change password:', error);
    }
}

export { getUserInfo, updateUserInfo, changePassword };